import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { action, computed, observable } from 'mobx'
import type { SupportingItemInputBase } from '../supporting-item-input'

/**
 * Props for {@link DocumentSupportingItemInput}.
 */
export type DocumentSupportingItemInputProps =
  ModelProps<DocumentSupportingItemInput> & { type: 'Document' }

/**
 * Supporting item input for documents.
 */
export class DocumentSupportingItemInput
  extends Model<DocumentSupportingItemInput>
  implements SupportingItemInputBase
{
  @observable accessor documentTypeShortId = Id.none
  @observable accessor documentIds: readonly Id[] = []

  /** @inheritDoc */
  @computed get isCompleted() {
    return this.documentIds.length > 0
  }

  /**
   * Adds the document ID to the list of provided documents.
   *
   * @param id
   */
  @action.bound
  addDocument(id: Id) {
    if (this.documentIds.includes(id)) {
      return
    }

    this.documentIds = [...this.documentIds, id]
  }

  /**
   * Removes the document ID from the list of provided documents.
   *
   * @param id
   */
  @action.bound
  removeDocument(id: Id) {
    if (!this.documentIds.includes(id)) {
      return
    }
    this.documentIds = this.documentIds.filter((docId) => docId !== id)
  }
}
